// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"585":"b2318049","600":"a5f235d6","799":"dc402208"}[chunkId] + ".chunk.css";
};